import { Button, type ButtonProps } from '@newcore/ui/buttons';
import { cn } from '@newcore/ui/cn';
import { FontWeights } from '@newcore/ui/enums/font-weights';
import { Sizes } from '@newcore/ui/enums/sizes';
import { ButtonVariants } from '@newcore/ui/enums/variants';
import { textVariants } from '@newcore/ui/variants/typography-text-variants';

// Login controls keep the pre-design-system geometry: 50px tall, 8px radius,
// flat (no elevation), regular weight, no active-press scale. Focus ring is
// preserved via the shared Button's focus-visible styles.
const LG_CHROME =
  'h-12.5 rounded-md px-4 shadow-none active:not-disabled:scale-100';
const REGULAR_WEIGHT = textVariants({ weight: FontWeights.REGULAR });

const LINK_VARIANTS: ButtonProps['variant'][] = [
  ButtonVariants.LINK_PRIMARY,
  ButtonVariants.LINK_SECONDARY,
];

const isLink = (variant: ButtonProps['variant']) =>
  LINK_VARIANTS.includes(variant);

export function LoginButton({ className, ...props }: ButtonProps) {
  const variant = props.variant ?? ButtonVariants.PRIMARY;
  const isLargeSize = props.size === Sizes.LG;
  const isPrimary = variant === ButtonVariants.PRIMARY;

  return (
    <Button
      {...props}
      className={cn(
        isLargeSize && LG_CHROME,
        isLargeSize && REGULAR_WEIGHT,
        isLargeSize && isPrimary && 'border-0',
        isLink(variant) && REGULAR_WEIGHT,
        className
      )}
    />
  );
}
